import { render, staticRenderFns } from "./PublicDashboard.vue?vue&type=template&id=45b98716&"
import script from "./PublicDashboard.vue?vue&type=script&lang=ts&"
export * from "./PublicDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports